export default __webpack_public_path__ + "static/kako-namestiti-lightroom-presets-android-5a438874095a03e52640b6bc8396dd8e.pdf";